import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  measurementsLength: 0,
  measurements: [],
}

export default function measurementsReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_MEASUREMENTS:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_MEASUREMENTS:
      return {...state, saveLoader: action.payload}
    case actions.GET_MEASUREMENTS:
      return {...state, measurements: action.payload.measurements, measurementsLength: action.payload.measurementsLength}
    default:
      return {...state};
  }
}